<template>
    <div>
        <h2>Considerations</h2>
        <table v-if="local.considerations.length > 0" class="table border-bottom">
            <tr v-for="(consideration, index) in local.considerations">
                <td>
                    <input type="text" v-model="consideration.name" :readonly="(index != activeConsiderationIndex)" class="form-control" :class="(index == activeConsiderationIndex) ? '':'readonly'">
                </td>
                <td class="text-right">
                    <button :class="(index == activeConsiderationIndex) ? 'active':''" class="btn btn-outline-secondary btn-sm" @click="editConsideration(index)">
                        <i v-if="(index == activeConsiderationIndex)" class='far fa-save'></i>
                        <i v-else="(index == activeConsiderationIndex)" class='far fa-edit'></i>
                    </button>
                    <button class="btn btn-outline-danger btn-sm" title="Remove" @click="removeConsideration(index)">
                        <i class="fas fa-times"></i>
                    </button>
<!--                    TODO: Edit conditions-->
                </td>
            </tr>
        </table>
        <p><span :class="considerationsMet ? 'text-success':'text-muted'"><i class="far fa-check-circle"></i></span> Enter at least {{ minConsiderations }} considerations </p>
        <form @submit.prevent="next()">
            <div v-if="errors.length" class="alert alert-warning">
                <ul>
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>

            <div class="form-group row">
                <label class="col-form-label col-md-2" for="considerationName">Consideration *</label>
                <div class="col-md">
                    <input type="text" class="form-control" placeholder="Consideration" id="considerationName" v-model="consideration" @keypress.enter.prevent="addConsideration">

                    <small class="text-muted pt-2 d-inline-block eg">
                        Current pH <br>
                        Likely Return on Investment in 3 years
                    </small>
                </div>
                <div class="col-md-2">
                    <input type="button" class="btn btn-primary" value="Add" @click.prevent="addConsideration">
                </div>
            </div>

            <div class="row justify-content-center">

                <input type="submit" class="btn btn-success" value="Next" :disabled="!considerationsMet">
            </div>
        </form>
    </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import {modalMixin} from '../mixins/modal';

export default {
    mixins: [
        modalMixin,
    ],
    data() {
        return {
            local: {
                matrix: {},
                considerations: [],
            },
            errors: [],
            consideration: '',
            activeConsiderationIndex: -1,
        };
    },
    props: {},
    computed: {

        considerationsMet() {
            return this.local.considerations.length >= this.minConsiderations;
        },
        ...mapState('config', [
            'minConsiderations',
        ]),
        ...mapState('data', {
            'dataMatrix': state => state.matrix,
            'dataConsiderations': state => state.matrix.considerations,
        }),
    },
    methods: {
        ...mapMutations('data', [
            'commitConsiderations',
        ]),
        next() {
            const vm = this;
            vm.commitConsiderations(vm.local.considerations);
            vm.$router.push({name: 'conditions'});
        },
        validate() {
            const vm = this;

            vm.$set(vm, 'errors', []);

            if (_.isEmpty(vm.consideration)) {
                vm.errors.push({name: 'Consideration cannot be blank'});
            }

            return vm.errors.length === 0;
        },

        addConsideration() {
            const vm = this;
            if (vm.validate()) {
                vm.local.considerations.push({
                    'name': vm.consideration,
                    conditions: []
                });
                vm.resetConsideration();
            }
        },

        editConsideration(index) {

            if(this.activeConsiderationIndex == index) {
                this.activeConsiderationIndex = -1;
            }else{
                this.activeConsiderationIndex = index
            }

        },

        removeConsideration(index) {
            const vm = this;
            vm.confirmAction('Are you sure you want to remove this consideration?').then(value => {
                if (value === true) {
                    vm.$delete(vm.local.considerations, index);
                }
            });

        },
        resetConsideration() {
            this.$set(this, 'consideration', '');
        },

    },
    mounted() {
        this.local.matrix = {...this.dataMatrix}
        this.local.considerations = [...this.dataConsiderations];
        //TODO: Force route back to decision if empty
    },

    watch: {
        dataConsiderations: function(){
            this.local.matrix = { ...this.dataConsiderations }
        }
    },
    //TODO: Warn on changes not saved

    beforeRouteLeave (to, from, next) {

      let matrixId = this.local.matrix.id
      let nextLinks = ['conditions', 'scores', 'decisiontable', 'scoreassessment', 'scenariotesting']

      if(_.isUndefined(matrixId)) {
        if(nextLinks.includes(to.name)) {
          if (this.considerationsMet) {
            next()
          }
        }else{
          next()
        }

      }else{
        next()
      }

    },

};
</script>
<style scoped>
    .readonly {
        background-color: transparent;
        border-width: 0;
    }
</style>

